var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navBar',{attrs:{"title":"Ares - Finance","home":true,"type":"hefc"}})
}
var staticRenderFns = []

export { render, staticRenderFns }